import React, {Component} from 'react';
import { connect } from 'react-redux'
import {Link} from 'react-router-dom';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import { Navigate , Route } from "react-router-dom"; 
import MUIDataTable from "mui-datatables";
import Header  from './header';
import BreadCrumb from './breadcrumb';
import Rodal from 'rodal';

// include styles
import 'rodal/lib/rodal.css';
import { red } from '@material-ui/core/colors';
class ViewBids extends Component{
    constructor (props) {
        super (props)

        this.state = {
            limit: 5,
            hasMoreItems: true,
            username:'',
            password:'',
            bids: [],visible: false,bidID:'',visibleUpdate:false,comment:'',bidStatus:''
        };
 
    }

    componentDidMount(){
      let self = this;
      var loaderElement = document.querySelector('#load_screen');
      setTimeout( function() {
          loaderElement.style.display = "none";
      }, 3000); 
    
    
     self.getAllRecord()

    };

    getAllRecord(){
      let self = this;
      var getDetails = new FormData(); 
      if(localStorage.getItem("ROLE") == "Admin" &&  localStorage.getItem("isAuth") == "true"){
        getDetails.append('OP', 'getAllBids');
      }else{
        getDetails.append('id', localStorage.getItem("USERID"));
        getDetails.append('OP', 'getBidsforUser');
      }
      
      axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
      .then(function (response) {
        console.log("BIDS",response.data); 
        if((response.data.status== "true" || response.data.status== true) && localStorage.getItem("ROLE") == "Admin" ){
  
          var data = [];
         for(var i = 0; i < response.data.response.length; i++){
         data.push(
            [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
            ,response.data.response[i]['comments'],<div  onClick={(event) => self.show(event.currentTarget.id)}  className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-danger">Delete</span></div>,
            response.data.response[i]['bidStatus'],<div onClick={(event) => self.showUpdate(event.currentTarget.id)}  className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-primary">Update Comment</span></div>,
          ],
         )
        // data = [[response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']],]
        
        }
        self.setState({bids:data});
        console.log("YOOO",data); 
       }else{
         if((response.data.status== "true" || response.data.status== true)){
         var data = [];
        for(var i = 0; i < response.data.response.length; i++){
        // data.push(
        //    [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
        //    ,response.data.response[i]['comments'],<div className="td-content" > <span className="badge outline-badge-danger">No Action Needed</span></div>,response.data.response[i]['bidStatus']],
        // )
        data.push(
          [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
          ,response.data.response[i]['comments'],<div className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-danger">No Action Needed</span></div>,
          <div className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-success">{response.data.response[i]['bidStatus']}</span></div>
        ],
       )
       // data = [[response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']],]
       
       }
       self.setState({bids:data});
       console.log("YOOO",data); 
        } }
      
      })
       .catch(function (error) {

        console.log(error);

      });
  
    }

    show(ID) {
    
     this.setState({ visible: true, bidID:ID });
      
    }
    showUpdate(ID){
     
     // this.setState({ bidID:ID });
      let self = this;
      var getDetails = new FormData(); 
      getDetails.append('id', ID);
      getDetails.append('OP', 'getComment');
      axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
      .then(function (response) {
        console.log("Comments",response.data); 
        if(response.data.status== "true" || response.data.status== true){
        self.setState({comment:response.data.comments,visibleUpdate: true,bidID:ID})
        console.log(response.data.response[0].comments)
      
       }
      
      })
       .catch(function (error) {

        console.log(error);

      });
    }

   
    updateComment(event){

      this.setState({comment:event.target.value})
      
    }
    changeStatus(e){
      this.setState({bidStatus:e.target.value})
      console.log(this.state.bidStatus)
    }
    DeleteThisRow(){
      let self = this;
      var getDetails = new FormData(); 
      getDetails.append('id', this.state.bidID);
      getDetails.append('OP', 'changeBidStatus');
      axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
      .then(function (response) {
        console.log("DELETED",response.data); 
        if(response.data.status== "true" || response.data.status== true){
        
          self.setState({ visible: false });
          self.getAllRecord()
       }
      
      })
       .catch(function (error) {

        console.log(error);

      });
    }
    
    hide() {
      this.setState({ visible: false });
    }

    addComment(){
      let self = this;
      var addComment = new FormData();
      addComment.append('id', this.state.bidID);
      addComment.append('comment', this.state.comment);
      addComment.append('bidStatus', this.state.bidStatus);
      addComment.append('OP', 'updateComment');
      axios.post('http://oliac.com/BMSCalls/bids.php',addComment)
      .then(function (response) {

        console.log("COMMENT",response);
        self.setState({ visibleUpdate: false });
        self.getAllRecord()
        toast.success('Comment Updated', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          closeButton:false,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          });
       
      })
      .catch(function (error) {
        console.log(error);
      });
    }
    getSelectiveBids(e){ 
      
        let self = this;
        var getDetails = new FormData(); 
        if(localStorage.getItem("ROLE") == "Admin" &&  localStorage.getItem("isAuth") == "true"){
          getDetails.append('OP', 'getPurchasedBid');
        }else{
          getDetails.append('id', localStorage.getItem("USERID"));
          getDetails.append('OP', 'getPurchasedBid');
        }
        
        axios.post('http://oliac.com/BMSCalls/bids.php',getDetails)
        .then(function (response) {
          console.log("BIDS",response.data); 
          if((response.data.status== "true" || response.data.status== true) && localStorage.getItem("ROLE") == "Admin" ){
    
            var data = [];
           for(var i = 0; i < response.data.response.length; i++){
           data.push(
              [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
              ,response.data.response[i]['comments'],<div  onClick={(event) => self.show(event.currentTarget.id)}  className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-danger">Delete</span></div>,
              response.data.response[i]['bidStatus'],<div onClick={(event) => self.showUpdate(event.currentTarget.id)}  className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-primary">Update Comment</span></div>,
            ],
           )
          // data = [[response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']],]
          
          }
          self.setState({bids:data});
          console.log("YOOO",data); 
         }else{
           if((response.data.status== "true" || response.data.status== true)){
           var data = [];
          for(var i = 0; i < response.data.response.length; i++){
          // data.push(
          //    [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
          //    ,response.data.response[i]['comments'],<div className="td-content" > <span className="badge outline-badge-danger">No Action Needed</span></div>,response.data.response[i]['bidStatus']],
          // )
          data.push(
            [response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']
            ,response.data.response[i]['comments'],<div className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-danger">No Action Needed</span></div>,
            <div className="td-content" id={response.data.response[i]['id']}> <span className="badge outline-badge-success">{response.data.response[i]['bidStatus']}</span></div>
          ],
         )
         // data = [[response.data.response[i]['bid_date'], response.data.response[i]['bid_time'],response.data.response[i]['bidUser'],response.data.response[i]['bid_auction'],response.data.response[i]['bid_no'],response.data.response[i]['bid_amount']],]
         
         }
         self.setState({bids:data});
         console.log("YOOO",data); 
          } }
        
        })
         .catch(function (error) {
  
          console.log(error);
  
        });
    
      
    }
   
    render (){
       // const columns = ["Date", "Time", "Bidder", "Auction", "Bid Number", "Amount","Comment","Action"];
        let columns;
       if(localStorage.getItem("ROLE") == "Admin"){ 
        columns = [
        {
         name: "Date",
         label: "Date",
         options: {
          filter: true,
          sort: true,
         }
        },
        {
         name: "Time",
         label: "Time",
         options: {
          filter: true,
          sort: false,
         }
        },
        {
         name: "Bidder",
         label: "Bidder",
         options: {
          filter: true,
          sort: false,
         }
        },
        {
         name: "Auction",
         label: "Auction",
         options: {
          filter: true,
          sort: false,
         }
        },
        {
          name: "Bid No",
          label: "Bid No",
          options: {
           filter: false,
           sort: false,
           setCellProps: () => ({ style: { color: "Red", fontWeight:'600'}}),
          }
         },
        {
          name: "Amount",
          label: "Amount",
          options: {
           filter: false,
           sort: false,
          }
         },
         {
          name: "Comment",
          label: "Comment",
          options: {
           filter: false,
           sort: false,
          }
         },
        
         {
          name: "Action",
          label: "Action",
          options: {
           filter: false,
           sort: false,
          }
         },
         {
          name: "Bid Status",
          label: "Bid Status",
          options: {
           filter: true,
           sort: true,
          }
         },

         {
          name: "Edit Comment",
          label: "Edit Comment",
          options: {
           filter: false,
           sort: false,
          }
         },


       ];}else{
        columns = [
          {
           name: "Date",
           label: "Date",
           options: {
            filter: true,
            sort: true,
           }
          },
          {
           name: "Time",
           label: "Time",
           options: {
            filter: true,
            sort: false,
           }
          },
          {
           name: "Bidder",
           label: "Bidder",
           options: {
            filter: true,
            sort: false,
           }
          },
          {
           name: "Auction",
           label: "Auction",
           options: {
            filter: true,
            sort: false,
           }
          },
          {
            name: "Bid No",
            label: "Bid No",
            options: {
             filter: false,
             sort: false,
            }
           },
          {
            name: "Amount",
            label: "Amount",
            options: {
             filter: false,
             sort: false,
            }
           },
           {
            name: "Comment",
            label: "Comment",
            options: {
             filter: false,
             sort: false,
            }
           },
          
           {
            name: "Action",
            label: "Action",
            options: {
             filter: false,
             sort: false,
            }
           },
           {
            name: "Bid Status",
            label: "Bid Status",
            options: {
             filter: true,
             sort: false,
            }
           },

 
         ]; 
       }
        // const columns = [
        //   {
        //    name: "Date",
        //    label: "Date",
        //    options: {
        //     filter: true,
        //     sort: true,
        //    }
        //   },
        //   {
        //    name: "Time",
        //    label: "Time",
        //    options: {
        //     filter: true,
        //     sort: false,
        //    }
        //   },
        //   {
        //    name: "Bidder",
        //    label: "Bidder",
        //    options: {
        //     filter: true,
        //     sort: false,
        //    }
        //   },
        //   {
        //    name: "Auction",
        //    label: "Auction",
        //    options: {
        //     filter: true,
        //     sort: false,
        //    }
        //   },
        //   {
        //     name: "Bid No",
        //     label: "Bid No",
        //     options: {
        //      filter: false,
        //      sort: false,
        //     }
        //    },
        //   {
        //     name: "Amount",
        //     label: "Amount",
        //     options: {
        //      filter: false,
        //      sort: false,
        //     }
        //    },
        //    {
        //     name: "Comment",
        //     label: "Comment",
        //     options: {
        //      filter: false,
        //      sort: false,
        //     }
        //    },
          
        //    {
        //     name: "Action",
        //     label: "Action",
        //     options: {
        //      filter: false,
        //      sort: false,
        //     }
        //    },
        //    {
        //     name: "Bid Status",
        //     label: "Bid Status",
        //     options: {
        //      filter: true,
        //      sort: false,
        //     }
        //    },

 
        //  ];
        const data = [
          ["Joe James", "Test Corp", "Yonkers", "NY"],
          ["John Walsh", "Test Corp", "Hartford", "CT"],
          ["Bob Herm", "Test Corp", "Tampa", "FL"],
          ["James Houston", "Test Corp", "Dallas", "TX"],
          ];
  
     //  console.log("real",data)

        const options = {
        
        selectableRows: 'single',
        filterType: 'dropdown',
        print: false,
        
        setRowProps: row => { 
          
          if (row[8] == "Purchased") {
            return {
              style: { background: "yellow",color:"white" }
            };
          }
        } ,
        customToolbarSelect: () => {}
        };
         
       
        return(
          
        <div>
        {/* BEGIN LOADER */}
        <div id="load_screen"> <div className="loader"> <div className="loader-content">
            <div className="spinner-grow align-self-center" />
        </div></div></div>
        {/*  END LOADER */}
          {/*  BEGIN NAVBAR  */}
          <Header/>
        {/*  END NAVBAR  */}
        <div className="main-container" id="container">
          <div className="overlay" />
          <div className="search-overlay" />
 
          <div id="content" className="main-content">
            <div className="layout-px-spacing">
             <BreadCrumb/>
              <div className="row layout-top-spacing layout-spacing">
              <div id="flLoginForm" className="col-lg-12 layout-spacing">
              <br/> 
              
              <span id="bidText" className="autoBidsBtn" style={{display: (localStorage.getItem("ROLE") == "Admin")? '' : 'none' }} onClick={(e)=> this.getSelectiveBids(e)}>View Purchased Bids</span>
              <span id="bidText" className="autoBidsBtn" style={{display: (localStorage.getItem("ROLE") == "Admin")? '' : 'none' }} onClick={(e)=> this.getAllRecord()}>Get All Records</span>

              {/* <span id="bidText" className="autoBidsBtn" onClick={(e)=> this.getSelectiveBids(e)}>View Purchased Bids</span>
              <span id="bidText" className="autoBidsBtn" onClick={(e)=> this.getSelectiveBids(e)}>View Sold Bids</span> 
              
                 */}
              <br/> <br/>  
              <MUIDataTable
                title={"All Bids"}
                data={this.state.bids}
                columns={columns}
                options={options}
                />
               <Rodal visible={this.state.visible} onClose={this.hide.bind(this)}>
                 <div>  

                 <h2>Are you Sure you want to Delete?</h2>
                 
                 <button type="button" id="btnRegis"
                  className="btn btn-primary mt-4" style={{marginRight:'10px'}} onClick={() => this.DeleteThisRow()}>Delete</button>

                  <button type="button" id="btnRegis"
                  className="btn btn-primary mt-4" onClick={() => this.hide() }>Close</button>

                 </div>
                 </Rodal>


                 <Rodal visible={this.state.visibleUpdate} onClose={()=>this.setState({visibleUpdate:false})}>
                 <div>  

                 <h2>Add Comment</h2>
                 <input type="text" className="form-control"  
                  placeholder="Comment"  value= {this.state.comment}
                    onChange={(e) => {this.updateComment(e)}}  />

                 <input type="hidden" 
                 className="form-control" 
                 placeholder="Comment" value= {this.state.bidID} 
                  

                  />
 
                  <select className="form-control basic" style={{marginTop:'10px'}} onChange={ (e) => this.changeStatus(e)}>

                  <option>Auction</option>

                  <option>Purchased</option>
                          
                  <option>Sold</option>

                  <option>Not Sold</option>

                  <option>Cancelled</option>
                          
                  </select> 

                 <button type="button" id="btnRegis" className="btn btn-primary mt-4" onClick={() => this.addComment()}>Add Comment</button>
                 <button type="button" id="btnRegis" className="btn btn-primary mt-4" style={{marginLeft:'10px'}} onClick={() => this.setState({visibleUpdate:false})}>Close</button>

                 </div>
                 </Rodal>
              </div>
              
               </div>
              <div className="footer-wrapper">
                <div className="footer-section f-section-1">
                  <p className>Copyright © 2022 <a target="_blank" href>BMS</a>, All rights reserved.</p>
                </div>
                <div className="footer-section f-section-2">
                  <p className>Coded with <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" className="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" /></svg></p>
                </div>
              </div>
            </div>
           
        </div> 
        </div>
       

   
        </div>
        );
     
    }
}
export default ViewBids;